export class ForgeProjectFeatureIteration {
    constructor(model) {
        var _a, _b;
        this.id = model.id;
        this.name = model.name;
        this.startedFromMessageId = model.startedFromMessageId;
        this.isInProgress = (_a = model.isInProgress) !== null && _a !== void 0 ? _a : false;
        this.state = model.state;
        this.error = model.error;
        this.baseIterationId = model.baseIterationId;
        this.staticPreviewUrl = model.staticPreviewUrl;
        this.isBookmarked = model.isBookmarked;
        this.thumbnail = model.thumbnail;
        this.artifactsDiff = (_b = model.artifactsDiff) !== null && _b !== void 0 ? _b : undefined;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : undefined;
    }
    toRemote() {
        var _a;
        return {
            ...this,
            createdAt: this.createdAt.toISOString(),
            updatedAt: (_a = this.updatedAt) === null || _a === void 0 ? void 0 : _a.toISOString(),
        };
    }
}
